export const routes = [
  {
    path: '/',
    name: 'home'
  },
  {
    path: '/:locale/',
    component: () => import('@/pages/App'),
    props: true,
    children: [
      {
        name: 'list',
        path: '',
        components: {
          header: () => import('@/components/AppHeader'),
          navigation: () => import('@/components/ListTabs'),
          default: () => import('@/pages/List'),
          footer: () => import('@/components/AppFooter')
        }
      },
      {
        name: 'client.profile.embed',
        path: ':id/embed',
        props: true,
        component: () => import('@/pages/ClientProfileEmbed')
      },
      {
        name: 'client.transaction.embed',
        path: ':id/transaction/embed',
        props: true,
        component: () => import('@/pages/ClientTransactionEmbed')
      },
      {
        path: ':id/',
        props: {
          default: true,
          navigation: true
        },
        components: {
          header: () => import('@/components/AppHeader'),
          navigation: () => import('@/components/ClientTabs'),
          default: () => import('@/pages/Client'),
          footer: () => import('@/components/AppFooter')
        },
        children: [
          {
            name: 'client.profile',
            path: '',
            component: () => import('@/pages/ClientProfile')
          },
          {
            name: 'client.transaction',
            path: 'transaction',
            component: () => import('@/pages/ClientTransaction')
          },
          {
            name: 'client.responses',
            path: 'responses',
            component: () => import('@/pages/ClientResponses')
          }
        ]
      }
    ]
  },
]

export default routes
